export const getFilteredObject = (inputObject, excludedKeys) => {
    // @ts-ignore
    const outputObject = Object.keys(inputObject)
        .filter((key) => !excludedKeys.includes(key))
        .reduce((acc, key) => {
        acc[key] = inputObject[key];
        return acc;
    }, {});
    return outputObject;
};
